import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const fetchDraftTakeawayOrders = ({ owner }) => {
    const filters = [["Draft Table Order", "status", "=", "Draft"]];
    if (owner) {
        filters.push(["Draft Table Order", "owner", "=", owner]);
    }

    const params = {
        doctype: "Draft Table Order",
        fields: JSON.stringify([
            "name",
            "customer",
            "address",
            "status",
            "table",
            "designated_number",
            "creation",
            "modified",
            "amount",
            "owner",
        ]),
        filters: JSON.stringify(filters),
        order_by: "modified desc",
        limit_start: 0,
        limit_page_length: 100,
    };

    return axios.get("method/frappe.client.get_list", { params });
};

export const useDraftTakeawayOrders = ({ owner } = {}) => {
    return useQuery(["draftTakeawayOrders", owner || ""], async () => {
        const { data } = await fetchDraftTakeawayOrders({ owner });
        return data.message || [];
    });
};
